<template>
    <div>
        <topback title="Link UPI KYC Partner" path="/kycpartner"></topback>
        <div class="partner mt-6">
            <md-field>
                <md-field-item title="Partner" :content="ct_type" @click="showSelector" arrow solid />
                <div v-if="type === 'freecharge' || type === 'mobikwik' || type === 'paytm'">
                    <clientlogin :type="type" :ct="ct" :operate="operate"></clientlogin>
                </div>
                <div v-else-if="type === 'phonepe' || type === 'airtel'">
                    <otplogin :type="type" :ct="ct" :operate="operate"></otplogin>
                </div>
                <div v-else-if="type === 'icicibank' || type === 'bharatpe'">
                    <servicelogin :type="type" :ct="ct" :operate="operate"></servicelogin>
                </div>
                <div v-else-if="type === 'induspay'">
                    <backapplogin :type="type" :ct="ct" :operate="operate"></backapplogin>
                </div>
                <div v-else-if="type === 'cubbank'">
                    <bankservicelogin :type="type" :ct="ct" :operate="operate"></bankservicelogin>
                </div>
            </md-field>
            <md-selector v-model="isSelectorShow" :data="ct_type_select" hide-title-bar large-radius is-check iconSize="lg"
                @choose="onSelectorChoose">
                <div class="selector-header" slot="header">
                    Choose a link authorization partner
                </div>
                <template slot-scope="{ option, index, selected }">
                    <div class="selector-item-body" :class="{ disabled: option.disabled, selected }">
                        <div class="selector-item-left">
                            <iconimg :name="option.value"></iconimg>
                        </div>
                        <div class="selector-item-content">
                            <p class="selector-item-title" v-text="option.text"></p>
                            <p class="selector-item-brief" v-text="`${option.describe}`"></p>
                        </div>
                    </div>
                </template>
                <div class="selector-footer" slot="footer">
                    Footer Slot
                </div>
            </md-selector>
        </div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import { DropMenu } from 'mand-mobile'
import servicelogin from '@/views/my/forms/servicelogin'
import clientlogin from '@/views/my/forms/clientlogin'
import backapplogin from '@/views/my/forms/backapplogin'
import bankservicelogin from '@/views/my/forms/bankservicelogin'
import otplogin from '@/views/my/forms/otplogin'
import { getconfigs, getcollectiontool } from '@/request/api'


export default {
    name: 'linkkycpartner',
    components: {
        topback,
        iconimg,
        DropMenu,
        servicelogin,
        bankservicelogin,
        backapplogin,
        clientlogin,
        otplogin
    },

    data() {
        return {
            isSelectorShow: false,
            ct_type_select: [
                {
                    value: 'induspay',
                    text: 'IndusPay',
                    describe: 'IndusPay is an Indian digital payment platform.',
                },
                {
                    value: 'airtel',
                    text: 'Airtel',
                    describe: 'Airtel is an Indian digital payment platform.'
                },
                {
                    value: 'freecharge',
                    text: 'Freecharge',
                    describe: 'Freecharge offers digital payment and mobile recharge services in India.',
                },
                {
                    value: 'phonepe',
                    text: 'Phonepe',
                    describe: 'PhonePe is an Indian digital payment platform.',
                },
                {
                    value: 'mobikwik',
                    text: 'Mobikwik',
                    describe: 'MobiKwik is an Indian digital payment platform.'
                },
                {
                    value: 'bharatpe',
                    text: 'Bharatpe',
                    describe: 'Bharatpe is an Indian digital payment platform.',
                    disabled: true,
                },
                {
                    value: 'cubbank',
                    text: 'Cub Bank',
                    describe: 'Cub Bank is an Indian digital payment platform.',
                },
                // {
                //     value: 'paytm',
                //     text: 'Paytm',
                //     describe: 'Paytm is an Indian digital payment platform.',
                //     disabled: true,
                // }

            ],
            ct_type: 'select the kyc partner',
            link_loading: false,
            type: "",
            ct_id: "",
            ct: null,
            operate: "add"
        }
    },
    created() {
        this.$toast.loading("Loading...")
        this.ct_id = this.$route.params.kycid;
        this.operate = this.$route.params.operate || "add";
        if (this.ct_id) {
            this.get_ct_detail();
        }
        getconfigs({ k: 'open_account_type' }).then(res => {
            if (res.code === 200) {
                this.$toast.hide();
                let opentype = res.data;
                for (let i = 0; i < this.ct_type_select.length; i++) {
                    this.ct_type_select[i].disabled = !opentype[this.ct_type_select[i].value];
                }
            } else {
                this.$toast.failed("The Kyc link is not open yet")
            }
        })
    },
    methods: {
        get_ct_detail() {
            console.log("获取详情 get_ct_detail linkkycpartner: ");
            getcollectiontool({ id: this.ct_id }).then(res => {
                if (res.code === 200) {
                    this.type = res.data.ct_type;
                    let obj = this.ct_type_select.find(item => item.value === this.type);
                    let text = obj ? obj.text : 'N/A';
                    this.ct_type = text;
                    this.ct = res.data;
                }
            })
        },
        showSelector() {
            this.isSelectorShow = true
        },
        onSelectorChoose({ value, text }) {
            this.ct_type = text
            this.type = value;
            console.log("onSelectorChoose linkkycpartner: ", value, text);
        },
    }
}

</script>
<style lang="stylus" scoped>
.partner
  .selector-header, .selector-footer
    padding 15px 40px
    font-size 16px
    color #ccc
  .selector-item-body
    display flex
    align-items center
    &.selected
      .selector-item-content
        color #2f86f6
    &.disabled
      opacity .3
    .selector-item-left
      flex-shrink 0
      margin-right 32px
      .holder
        display block
        width 88px
        height 88px
        border-radius 44px
        background-color #e6e6e6
        font-size 32px
        font-weight 500
        color #2f86f6
        text-align center
        line-height 88px
    .selector-item-content
      flex 1
      color #111a34
      font-size 32px
      line-height 1.2
      .selector-item-title
        line-height 1.2
      .selector-item-brief
        color #858b9c
        font-size 24px
        line-height 1.4
        margin-top 8px
</style>



// WEBPACK FOOTER //
// src/views/my/linkkycpartner.vue